// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__1QF_8","content":"style_content__3w5nw","closeBtn":"style_closeBtn__7S_95"};